class OkCategoryMenu extends HTMLElement {
  connectedCallback() {
    this.buttons = Array.from(this.querySelectorAll('[data-ok-category-target]'));
    this.panels = Array.from(this.querySelectorAll('[data-ok-category-panel]'));

    if (!this.buttons.length || !this.panels.length) return;

    this.buttons.forEach((button, index) => {
      button.addEventListener('pointerenter', () => this.activate(button.dataset.okCategoryTarget));
      button.addEventListener('focus', () => this.activate(button.dataset.okCategoryTarget));
      button.addEventListener('click', () => {
        const url = button.dataset.okCategoryUrl;
        if (url) {
          window.location.assign(url);
          return;
        }
        this.activate(button.dataset.okCategoryTarget, true);
      });
      button.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
  }

  activate(key, focusPanel = false) {
    let activePanel = null;

    this.buttons.forEach((button) => {
      const isActive = button.dataset.okCategoryTarget === key;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', String(isActive));
      button.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel) => {
      const isActive = panel.dataset.okCategoryPanel === key;
      panel.hidden = !isActive;
      if (isActive) activePanel = panel;
    });

    if (focusPanel && activePanel) {
      const firstLink = activePanel.querySelector('a');
      firstLink?.focus({ preventScroll: true });
    }
  }

  onKeydown(event, index) {
    let nextIndex = null;

    if (event.key === 'ArrowDown') nextIndex = (index + 1) % this.buttons.length;
    if (event.key === 'ArrowUp') nextIndex = (index - 1 + this.buttons.length) % this.buttons.length;
    if (event.key === 'Home') nextIndex = 0;
    if (event.key === 'End') nextIndex = this.buttons.length - 1;
    if (event.key === 'ArrowRight' || event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.activate(this.buttons[index].dataset.okCategoryTarget, true);
      return;
    }

    if (nextIndex === null) return;

    event.preventDefault();
    const nextButton = this.buttons[nextIndex];
    this.activate(nextButton.dataset.okCategoryTarget);
    nextButton.focus();
  }
}

if (!customElements.get('ok-category-menu')) {
  customElements.define('ok-category-menu', OkCategoryMenu);
}

const categoryTriggerSelector = '.menu-list__link[href="#OkCategoryMenu"]';

function getCategoryTrigger(event) {
  return event.target instanceof Element ? event.target.closest(categoryTriggerSelector) : null;
}

document.addEventListener(
  'click',
  (event) => {
    const trigger = getCategoryTrigger(event);
    if (!(trigger instanceof HTMLElement)) return;

    const headerMenu = trigger.closest('header-menu');
    if (headerMenu && typeof headerMenu.toggleCustomMenu === 'function') {
      headerMenu.toggleCustomMenu(event, trigger);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    trigger.setAttribute('aria-expanded', String(trigger.getAttribute('aria-expanded') !== 'true'));
  },
  true
);

document.addEventListener(
  'keydown',
  (event) => {
    if (event.key !== 'Escape') return;

    const trigger = getCategoryTrigger(event);
    if (!(trigger instanceof HTMLElement)) return;

    const headerMenu = trigger.closest('header-menu');
    if (headerMenu && typeof headerMenu.closeCustomMenu === 'function') {
      event.preventDefault();
      headerMenu.closeCustomMenu(trigger);
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus({ preventScroll: true });
  },
  true
);
